import {
    AfterViewInit,
    Component,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';

import {
    CommonModule
} from '@angular/common';

import {
    MatTab,
    MatTabChangeEvent,
    MatTabGroup,
    MatTabGroupBaseHeader,
    MatTabsModule
} from '@angular/material/tabs';

import { Categories } from 'tilby-models';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TilbyGesturesDirective } from '@tilby/tilby-ui-lib/directives/tilby-gestures';
import { TranslateModule } from '@ngx-translate/core';

import {
    ActiveSaleService,
    CashregisterStateService,
    Section
} from 'src/app/features';

@Component({
    selector: 'app-category-tab',
    templateUrl: 'category-tab.component.html',
    styleUrls: ["./category-tab.component.scss"],
    standalone: true,
    imports: [
        CommonModule,
        ScrollingModule,
        MatTabsModule,
        TilbyGesturesDirective,
        TranslateModule
    ],
})
export class CategoryTabComponent implements AfterViewInit, OnChanges {
    protected activeSaleService = inject(ActiveSaleService);
    protected cashregisterStateService = inject(CashregisterStateService);

    @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
    @Input({ required: true }) categoriesSet!: Categories[];
    @Input() itemsFavorite: boolean = false;
    @Input() initCategorySelected?: Categories;
    @Input() fontNameSize: number = 12;
    @Output() categorySelected = new EventEmitter<Categories>();
    @Output() goToSection = new EventEmitter<Section>();

    protected tabIndex = 0;

    ngAfterViewInit(): void {
        const index = this.initCategorySelected ? this.categoriesSet.findIndex(category => category.id === this.initCategorySelected!.id) : -1;
        this.tabIndex = this.itemsFavorite ? (index + 1) : index;

        // Override tab click, call original only if we are not adding an item
        const originalHandleClick = this.tabGroup._handleClick;

        this.tabGroup._handleClick = (tab: MatTab, group: MatTabGroupBaseHeader, index: number) => {
            if (!this.onCategoryTabClick(index)) {
                originalHandleClick.apply(this.tabGroup, [tab, group, index]);
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.fontNameSize) {
            this.fontNameSize = changes.fontNameSize.currentValue;
        }
    }

    onCategoryTabClick(idx: number) {
        const index = this.itemsFavorite ? (idx - 1) : idx;

        if (index === -1) {
            return;
        }

        const amount = this.cashregisterStateService.keyboardTotalValue();
        const currentPriceList = this.cashregisterStateService.priceList();
        const category = this.categoriesSet[index];

        if (amount && category[`department${currentPriceList == 1 ? '' : currentPriceList}_id` as keyof Categories]) {
            this.cashregisterStateService.addDynamicCategoryItemToSale$.next({
                price: amount,
                category: category
            });

            return true;
        }
    }

    emitCategorySelection(event: MatTabChangeEvent) {
        const index = this.itemsFavorite ? (event.index - 1) : event.index;

        if (index === -1) {
            this.goToSection.emit('favorites');
        } else {
            this.categorySelected.emit(this.categoriesSet[index]);
        }
    }

    swipeRight() {
        this.tabGroup._tabHeader.scrollDistance -= 300;
    }

    swipeLeft() {
        this.tabGroup._tabHeader.scrollDistance += 300;
    }
}
